import React from 'react';
import { Field, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { compose } from 'redux';
import FlatButton from 'material-ui/FlatButton';
import SearchableSelectRedux from 'components/shared/SearchableSelectRedux';

import '../tenant_app/components/tenant_profile/TenantProfile.css';
import * as validator from 'helpers/Validator';
import Subheader from 'material-ui/Subheader';
import { AccentColor } from 'helpers/AccentColorHelper';

const style = {
  button: {
    color: 'white',
    height: '40px',
  },
  subheader: {
    lineHeight: 0,
    padding: '20px 0px 15px 0px',
  },
};

let AssignToAgentForm = props => {
  const { handleSubmit, agents, units } = props;

  return (
    <div className="row" style={{ margin: 'auto', maxWidth: '250px' }}>
      <form onSubmit={handleSubmit}>
        {units && (
          <div className="row">
            <Subheader inset={false} style={style.subheader}>
              Unit Shown
            </Subheader>
            <Field
              fullWidth
              name="unit"
              component={SearchableSelectRedux}
              options={units}
              validate={[validator.required]}
            />
          </div>
        )}
        <div className="row" style={{ marginTop: '8px' }}>
          <Subheader inset={false} style={style.subheader}>
            Assign To
          </Subheader>
          <Field
            name="assign"
            component={SearchableSelectRedux}
            options={agents}
            menuStyle={{ fontSize: '14px' }}
            style={{ fontSize: '14px' }}
            fullWidth
            validate={[validator.multi_select_required]}
          />
        </div>
        <div className="row" style={{ textAlign: 'center', marginTop: '15px' }}>
          <FlatButton
            label={units ? 'Complete' : 'Change Agent'}
            type="submit"
            primary={true}
            backgroundColor={AccentColor()}
            hoverColor="grey"
            style={style.button}
          />
        </div>
      </form>
    </div>
  );
};

AssignToAgentForm = compose(
  connect((_, ownProps) => {
    return {
      form: ownProps.formName,
    };
  }),
  reduxForm({
    destroyOnUnmount: true,
    forceUnregisterOnUnmount: true,
  })
)(AssignToAgentForm);

export default AssignToAgentForm;
